import styled, { css } from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';
import { mediaMinWidth } from 'themes/mixins/mediaQueries';

import { Headline } from 'components/Headline';

const Title = styled(Headline)`
  margin-bottom: 5rem;
`;

const HeadlineInfo = styled(Headline)`
  padding: 0.8rem 0;

  &::after {
    content: '';

    display: block;

    border-bottom: 0.2rem solid ${pickColor('borderLight')};
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  width: 100%;
  height: auto;

  color: ${pickColor('grayDark')};

  ${mediaMinWidth.md(css`
    display: block;
  `)};
`;

Wrapper.displayName = 'Wrapper';

export { Title, HeadlineInfo, Wrapper };
